export const SITE_AUTODIAG_CARD_FRENCH_LOCALE = {
  title: "Diagnostic en temps réel",
  warning:
    'Avant tout diagnostic, s\'assurer que tous les disjoncteurs au tableau électrique sont sur ON (ou en position Haute) et cliquer sur "Synchroniser programmation MyV"',
};
